import { ReactNode } from 'react';
import { getSessao } from '../lib/auth';
import { LoginPage } from '../pages/Login';
import { useSupabase } from '../lib/supabase.tsx';

export function AuthGuard({ children }: { children: ReactNode }) {
  const { ready, error } = useSupabase();

  if (!ready) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <p>Carregando...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <p style={{ color: 'red' }}>Erro ao conectar: {error}</p>
      </div>
    );
  }

  const sessao = getSessao();
  if (!sessao) return <LoginPage />;

  return <>{children}</>;
}
